import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GitStashedChangesDialogModule } from '../git-stashed-changes-dialog/git-stashed-changes-dialog.module';
import { GitStashedChangesButtonComponent } from './git-stashed-changes-button.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatButtonModule, MatTooltipModule, GitStashedChangesDialogModule],
  declarations: [GitStashedChangesButtonComponent],
  exports: [GitStashedChangesButtonComponent],
})
export class GitStashedChangesButtonModule {}
